module.exports = __webpack_public_path__ + "media/images/dashboard/light/tile_icon_top_advertisers-f51acf094b456205a161f27b65ad95be.png";